import createReducer from '../../../store/createReducer';
import {
    UPDATE_FIELD_VALUE_FF,
    UPDATE_FORM_STATUS_FF,
    SUBMIT_IN_PROGRESS_FF,
    SUBMIT_SUCCESS_FF,
    SUBMIT_ERROR_FF,
    RESET_FORM_FF
} from '../actions/feedbackFormActions';

function updateFormStatus(state, action) {
    return {
        ...state,
        [action.payload.fieldName]: action.payload.value
    };
}

function submitInProgress(state) {
    return {
        ...state,
        formSubmitInProgress: true
    };
}

function submitSuccess(state) {
    return {
        ...state,
        formSubmitInProgress: false,
        formSubmitted: true,
        formFailed: false
    };
}

function submitError(state, action) {
    return {
        ...state,
        formSubmitInProgress: false,
        formFailed: true,
        message: action.payload.msg
    };
}

function updateFieldValue(state, action) {
    return {
        ...state,
        fields: {
            ...state.fields,
            [action.payload.name]: {
                ...state.fields[action.payload.name],
                touched: true,
                value: action.payload.value
            }
        }
    };
}

export const initialState = {
    fields: {
        email: {
            value: '',
            required: false
        },
        userName: {
            value: '',
            required: false
        },
        overall: {
            value: '',
            required: true
        },
        overallComment: {
            value: '',
            required: false
        },
        learnAbout: {
            value: '',
            required: true
        },
        program: {
            value: '',
            required: true
        },
        programBestSpeaker: {
            value: '',
            required: false
        },
        programWorstSpeaker: {
            value: '',
            required: false
        },
        location: {
            value: '',
            required: true
        },
        locationComment: {
            value: '',
            required: false
        },
        perception: {
            value: '',
            required: true
        },
        otherComments: {
            value: '',
            required: false
        }
    },
    formFailed: false,
    formSubmitted: false,
    formSubmitInProgress: false,
    message: ''
};

function resetForm() {
    return initialState;
}

export default createReducer(initialState, {
    [UPDATE_FIELD_VALUE_FF]: updateFieldValue,
    [UPDATE_FORM_STATUS_FF]: updateFormStatus,
    [SUBMIT_IN_PROGRESS_FF]: submitInProgress,
    [SUBMIT_SUCCESS_FF]: submitSuccess,
    [SUBMIT_ERROR_FF]: submitError,
    [RESET_FORM_FF]: resetForm
});
